import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

export interface Plan {
  id: number;
  code: number;
  name: string;
  priceCents: number;
  currency: string;
  interval: "year";
  metadata: any;
}

interface PlanState {
  plans: Plan[];
  plan?: Plan;
  status: "idle" | "loading" | "failed";
}

const initialState: PlanState = {
  plans: [],
  plan: undefined,
  status: "idle",
};

// 🔄 Thunks
export const fetchAllPlans = createAsyncThunk(
  "plan/fetchAllPlans",
  async () => {
    const response = await axiosInstance.get(`/plans`);
    return response.data;
  }
);

export const fetchPlansByAssociationID = createAsyncThunk(
  "plan/fetchPlansByAssociationID",
  async (associationId: number) => {
    const response = await axiosInstance.get(
      `/plans/association/${associationId}`
    );
    return response.data;
  }
);

export const fetchPlanById = createAsyncThunk(
  "plan/fetchPlanById",
  async (id: number) => {
    const response = await axiosInstance.get(`/plan/${id}`);
    return response.data;
  }
);

// 🧬 Slice
const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // All Plans
      .addCase(fetchAllPlans.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllPlans.fulfilled, (state, action) => {
        state.status = "idle";
        state.plans = action.payload;
      })
      .addCase(fetchAllPlans.rejected, (state) => {
        state.status = "failed";
      })

      // Plans by Association
      .addCase(fetchPlansByAssociationID.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPlansByAssociationID.fulfilled, (state, action) => {
        state.status = "idle";
        state.plans = action.payload;
      })
      .addCase(fetchPlansByAssociationID.rejected, (state) => {
        state.status = "failed";
      })

      // Single Plan
      .addCase(fetchPlanById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPlanById.fulfilled, (state, action) => {
        state.status = "idle";
        state.plan = action.payload;
      })
      .addCase(fetchPlanById.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default planSlice.reducer;
